<template>
  <div
    v-scroll-lock="true"
    class="modal active"
  >
    <div class="modal-overlay" />

    <div class="modal-container modal-form modal-form--sm">
      <header class="modal-header modal-form__header">
        <a
          aria-label="close"
          class="btn btn-clear float-right modal-form__close"
          @click="close"
        />
      </header>

      <article
        id="print"
        class="modal-body modal-form__body"
      >
        <div class="modal-form__wrapper receipt">
          <transition name="fade">
            <dr-loader
              v-if="ui.isLoading"
              size="lg"
              class="receipt__loader"
            />
          </transition>

          <transition-group
            name="fade"
            class="w-full"
          >
            <div
              v-if="!ui.isLoading"
              key="receipt-header"
              class="receipt__header"
            >
              <h1 class="receipt__title">
                Recibo
              </h1>

              <img
                class="receipt__logo"
                src="@/assets/img/home/logo_web.png"
                width="150"
              />
            </div>

            <dl
              v-if="!ui.isLoading"
              key="receipt-details"
              class="receipt__items w-full"
            >
              <template
                v-for="(field, index) in receipt"
              >
                <dt
                  :key="`fieldName-${index}`"
                  class="receipt__term"
                  style="flex: 0 0 40%"
                >
                  {{ field.key }}
                </dt>

                <dd
                  v-html="field.value"
                  :key="`fieldValue-${index}`"
                  class="receipt__info"
                  style="flex: 0 0 60%"
                />
              </template>
            </dl>
          </transition-group>
        </div>
      </article>

      <transition name="fade">
        <footer
          v-if="!ui.isLoading"
          class="modal-form__footer"
        >
          <button
            class="modal-form__btn-secondary mr-auto"
            @click="printReceipt()"
          >
            Imprimir
          </button>
        </footer>
      </transition>
    </div>

    <print-template
      v-if="ui.isPrint"
      :agenda="1"
      :active="ui.isPrint"
      :formData="receipt"
      type="receipt"
    />
  </div>
</template>

<script>
export default {
  name: 'DrReceipt',

  props: {
    receipt: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      ui: {
        showSendEmail: false,
        isLoading: false,
        isPrint: false
      },
      email: null
    }
  },

  methods: {
    close () {
      this.receipt = null
      this.$emit('close')
    },

    printReceipt () {
      this.$htmlToPaper('print', () => {
        console.log('teste')
        // this.$emit('cancel', true)
      })
    }
  }
}
</script>
